import * as helpers from '../../static/js/plugins/helpers';

let $window = $(window);
let $body = $(document.body);
let $menu = $('.js-sticky-menu');
let $burger = $('.js-burger');

if ($(window).width() > 1024) {
    $window.on('scroll', () => {
        $menu.toggleClass('is-fixed', $window.scrollTop() > 150).removeClass("is-active");
        $body.removeClass('is-top');
        $burger.removeClass('is-active');
    });
}

$(window).on("resize", function(){
    if ($menu.hasClass("is-active")) {
        $(window).width() <= 1024 ?
            $body.removeClass('is-top').addClass('page-stop') :
            $body.removeClass('page-stop').addClass('is-top');
    }
})

$burger.on('click', (e) => {
    $(e.currentTarget).toggleClass('is-active');
    $menu.toggleClass('is-active');

    if ($window.scrollTop() <= 0 && $(window).width() > 1024) {
        $body.toggleClass('is-top');
    } else if ($(window).width() <= 1024) {
        $body.toggleClass('page-stop');
    }
});

$('.js-sticky-bg').on('click', (e) => {
    $burger.removeClass('is-active');
    $menu.removeClass('is-active');
    $body.removeClass('page-stop');
});

$('.js-user-modal').on('click', (e) => {
    if ($(window).width() <= 1024) {
        $(e.currentTarget).toggleClass('is-active');
        $('.header__login__user__menu').fadeToggle();
        helpers.saveScrollPosition();
        $('.modal__shadow').fadeToggle();
        $('body').toggleClass('modal-open');
    }
});
